const fetchWithAuth = async (url, options = {}, onSessionExpired, timeout = 10000) => {
  const controller = new AbortController();
  const id = setTimeout(() => {
    console.log(`Request to ${url} timed out after ${timeout}ms`);
    controller.abort();
  }, timeout);

  try {
    const token = localStorage.getItem('memberToken');
    const headers = {
      ...options.headers,
      'Content-Type': 'application/json',
      ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
    };

    const response = await fetch(url, {
      ...options,
      headers,
      signal: controller.signal,
      credentials: 'include',
    });
    clearTimeout(id);

    if (!response.ok) {
      if (response.status === 401 && url.endsWith('/login')) {
        console.log('Login failed with 401, likely invalid password');
        throw new Error('Invalid password');
      } else if (response.status === 401) {
        // Only trigger session expired for critical authentication routes
        if (url.includes('/login') || url.includes('/validate-token') || url.includes('/refresh-token')) {
          console.log('Unauthorized request for critical auth route, triggering session expired');
          if (onSessionExpired) onSessionExpired();
          throw new Error('Session expired');
        }
        console.log(`Unauthorized request for ${url}, passing error to caller`);
        throw new Error('Unauthorized request');
      } else if (response.status === 404) {
        console.log(`Resource not found for ${url}`);
        throw new Error('Not found');
      } else if (response.status === 429) {
        console.log(`Too many requests for ${url}`);
        throw new Error('Too many requests');
      }

      let errorData;
      try {
        errorData = await response.json();
      } catch (jsonErr) {
        errorData = { error: `HTTP ${response.status} ${response.statusText}` };
      }
      throw new Error(errorData.error || `Failed to fetch (status: ${response.status})`);
    }

    return response;
  } catch (err) {
    clearTimeout(id);
    if (err.name === 'AbortError') {
      throw new Error('Request timed out');
    }
    if (err.message !== 'Session expired') {
      console.error(`Fetch error for ${url}:`, {
        name: err.name,
        message: err.message,
        stack: err.stack,
      });
    }
    throw err;
  }
};

export default fetchWithAuth;